import { render } from "./NcrmPrivacyStatusChip.vue?vue&type=template&id=7a6c8f55"
import script from "./NcrmPrivacyStatusChip.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyStatusChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__